module.exports = __webpack_public_path__ + "e5df8baef59424620369b2245df66b46.png";